import { httpClient } from "@/services";
import { splitArray } from "@/helper";

export default {
	state: {
		calendarDates: null,
		calendarList: null,
		filterCalendarPayments: null,
		calendarFilterList: null
	},
	mutations: {
		updateCalendar(state, { dates, filter }) {
			state.filterCalendarPayments = filter;
			state.calendarDates = splitArray(dates, 7);
		},
		updateCalendarList(state, { list, filter }) {
			state.calendarList = list;
			state.calendarFilterList = filter;
		},
	},
	actions: {
		async getCalendar({ commit, dispatch }) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post('scheduled-payments/list');
				if (data) {
					commit('updateCalendar', data);
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async onCalendar(context, id) {
			const url = id ? `scheduled-payments/create?customer_id=${ id }` : 'scheduled-payments/create';
			try {
				const { data } = await httpClient.get(url);
				return data;
			} catch (e) {
				console.error(e);
			}
		},
		async onCalendarCreate(context, values) {
			try {
				const { data } = await httpClient.post('scheduled-payments', values);
				if (data) {
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getCalendarOnDate({ commit }, values) {
			try {
				const { data } = await httpClient.post('scheduled-payments/list', values);
				if (data) {
					commit('updateCalendar', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getEditCalendar(context, { id, date }) {
			try {
				const { data } = await httpClient.get(`scheduled-payments/${ id }/edit/${ date }`);
				if (data) return data;
			} catch (e) {
				console.error(e);
			}
		},
		async onEditCalendar({ dispatch }, values) {
			const { id, ...obj } = values;
			try {
				const { data } = await httpClient.put(`scheduled-payments/${ id }`, obj);
				if (data) {
					dispatch('setAlert', { type: "success", message: "Edit payment" });
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getCalendarList({ commit }, { date, filters = null }) {
			try {
				const { data } = await httpClient.post(`scheduled-payments/date/${ date }`, filters);
				if (data) {
					commit('updateCalendarList', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onDeletePayment({ dispatch }, { id, payment_type }) {
			try {
				const { data } = await httpClient.post(`scheduled-payments/destroy/${ id }`, { payment_type });
				if (data && data.status) {
					dispatch('setAlert', { type: "success", message: "Remove payment" });
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
	},
	getters: {
		calendarDates: s => s.calendarDates,
		calendarFilterList: s => s.calendarFilterList,
		filterCalendarPayments: s => s.filterCalendarPayments,
		calendarList: s => s.calendarList
	}
};
